const dataBorders = [
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-62.84, -22.03],
        [-63.98, -21.99],
        [-64.37, -22.79],
        [-64.96, -22.07],
        [-66.27, -21.83],
        [-67.1, -22.73],
        [-67.82, -22.87],
        [-68.21, -21.49],
        [-68.75, -20.37],
        [-68.44, -19.4],
        [-68.96, -18.98],
        [-69.1, -18.26],
        [-69.59, -17.58],
        [-68.95, -16.5],
        [-69.38, -15.66],
        [-69.16, -15.32],
        [-69.33, -14.95],
        [-68.94, -14.45],
        [-68.92, -13.6],
        [-68.88, -12.89],
        [-68.66, -12.56],
        [-69.52, -10.95],
        [-68.78, -11.03],
        [-68.27, -11.01],
        [-68.04, -10.71],
        [-67.17, -10.3],
        [-66.64, -9.93],
        [-65.33, -9.76],
        [-65.44, -10.51],
        [-65.32, -10.89],
        [-65.4, -11.56],
        [-64.31, -12.46],
        [-63.19, -12.62],
        [-62.8, -13.0],
        [-62.12, -13.19],
        [-61.71, -13.48],
        [-61.08, -13.47],
        [-60.5, -13.77],
        [-60.45, -14.35],
        [-60.26, -14.64],
        [-60.25, -15.07],
        [-60.54, -15.09],
        [-60.15, -16.25],
        [-58.24, -16.29],
        [-58.38, -16.87],
        [-58.28, -17.27],
        [-57.73, -17.55],
        [-57.49, -18.17],
        [-57.67, -18.96],
        [-57.9, -19.4],
        [-57.85, -19.97],
        [-58.16, -20.17],
        [-58.18, -19.86],
        [-59.11, -19.35],
        [-60.04, -19.34],
        [-61.78, -19.63],
        [-62.26, -20.51],
        [-62.29, -21.05],
        [-62.68, -22.24],
        [-62.84, -22.03],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-130.53, 54.8],
        [-129.9, 55.28],
        [-130.0, 55.91],
        [-131.7, 56.55],
        [-132.73, 57.69],
        [-133.35, 58.41],
        [-134.27, 58.86],
        [-134.94, 59.27],
        [-135.47, 59.78],
        [-136.47, 59.46],
        [-137.45, 58.9],
        [-138.34, 59.56],
        [-139.03, 60],
        [-140.01, 60.27],
        [-140.99, 60.3],
        [-140.99, 66.0],
        [-140.98, 69.71],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-117.12, 32.53],
        [-115.99, 32.61],
        [-114.72, 32.72],
        [-114.81, 32.52],
        [-113.3, 32.03],
        [-111.02, 31.33],
        [-109.04, 31.33],
        [-108.24, 31.34],
        [-108.2, 31.75],
        [-106.5, 31.75],
        [-106.14, 31.39],
        [-105.63, 31.08],
        [-105.03, 30.64],
        [-104.7, 30.12],
        [-104.45, 29.57],
        [-103.9, 29.2],
        [-103.1, 28.9],
        [-102.4, 29.7],
        [-101.66, 29.77],
        [-100.95, 29.38],
        [-100.45, 28.69],
        [-100.1, 28.1],
        [-99.5, 27.5],
        [-99.3, 26.8],
        [-99.0, 26.3],
        [-98.2, 26.0],
        [-97.5, 25.8],
        [-97.1, 25.8],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-90.09, 13.73],
        [-90.06, 13.88],
        [-89.72, 14.13],
        [-89.53, 14.24],
        [-89.58, 14.36],
        [-89.35, 14.42],
        [-89.14, 14.67],
        [-89.22, 14.87],
        [-89.15, 15.06],
        [-88.68, 15.34],
        [-88.22, 15.72],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-92.22, 14.53],
        [-92.2, 14.83],
        [-92.08, 15.06],
        [-92.22, 15.25],
        [-91.74, 16.06],
        [-90.46, 16.06],
        [-90.43, 16.41],
        [-90.6, 16.47],
        [-90.71, 16.68],
        [-91.08, 16.91],
        [-91.45, 17.25],
        [-91.0, 17.25],
        [-91.0, 17.81],
        [-90.06, 17.81],
        [-89.14, 17.8],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-88.93, 15.88],
        [-89.22, 15.88],
        [-89.15, 17.01],
        [-89.14, 17.8],
        [-89.15, 17.95],
        [-89.02, 18.0],
        [-88.84, 17.88],
        [-88.49, 18.48],
        [-88.3, 18.49],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-89.35, 14.42],
        [-89.05, 14.34],
        [-88.84, 14.14],
        [-88.54, 13.98],
        [-88.5, 13.84],
        [-88.06, 13.96],
        [-87.85, 13.89],
        [-87.72, 13.78],
        [-87.79, 13.38],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-87.31, 12.98],
        [-87.0, 13.02],
        [-86.88, 13.25],
        [-86.73, 13.26],
        [-86.75, 13.75],
        [-86.52, 13.77],
        [-86.31, 13.77],
        [-86.09, 14.03],
        [-85.8, 13.83],
        [-85.69, 13.96],
        [-85.51, 14.07],
        [-85.16, 14.35],
        [-85.14, 14.56],
        [-85.05, 14.55],
        [-84.92, 14.79],
        [-84.82, 14.81],
        [-84.64, 14.66],
        [-84.44, 14.62],
        [-84.22, 14.74],
        [-83.97, 14.74],
        [-83.62, 14.88],
        [-83.48, 15.01],
        [-83.14, 14.99],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-82.96, 8.22],
        [-82.91, 8.42],
        [-82.82, 8.62],
        [-82.86, 8.8],
        [-82.71, 8.92],
        [-82.92, 9.07],
        [-82.93, 9.47],
        [-82.54, 9.56],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-83.65, 10.93],
        [-83.89, 10.72],
        [-84.19, 10.79],
        [-84.35, 10.99],
        [-84.67, 11.08],
        [-84.9, 10.95],
        [-85.56, 11.21],
        [-85.71, 11.08],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[-77.35, 8.67], [-77.47, 8.52], [-77.24, 7.93], [-77.43, 7.63], [-77.75, 7.7], [-77.88, 7.22]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-71.33, 11.77],
        [-71.97, 11.6],
        [-72.22, 11.1],
        [-72.61, 10.82],
        [-72.9, 10.45],
        [-73.02, 9.73],
        [-73.3, 9.15],
        [-72.78, 9.08],
        [-72.66, 8.62],
        [-72.43, 8.4],
        [-72.36, 8.0],
        [-72.47, 7.63],
        [-72.44, 7.42],
        [-72.19, 7.34],
        [-71.96, 6.99],
        [-70.67, 7.08],
        [-70.09, 6.96],
        [-69.38, 6.09],
        [-68.98, 6.2],
        [-68.26, 6.15],
        [-67.69, 6.26],
        [-67.34, 6.09],
        [-67.52, 5.55],
        [-67.74, 5.22],
        [-67.82, 4.5],
        [-67.62, 3.83],
        [-67.33, 3.54],
        [-67.3, 3.31],
        [-67.8, 2.82],
        [-67.44, 2.6],
        [-67.18, 2.25],
        [-66.87, 1.25],
        [-67.06, 1.13],
        [-67.2, 1.7],
        [-67.53, 2.03],
        [-67.86, 1.69],
        [-69.81, 1.71],
        [-69.8, 1.08],
        [-69.21, 0.98],
        [-69.25, 0.6],
        [-69.45, 0.7],
        [-70.01, 0.54],
        [-70.02, -0.18],
        [-69.57, -0.54],
        [-69.42, -1.12],
        [-69.44, -1.55],
        [-69.89, -4.29],
        [-70.39, -3.76],
        [-70.69, -3.74],
        [-70.04, -2.72],
        [-70.81, -2.25],
        [-71.41, -2.34],
        [-71.77, -2.16],
        [-72.32, -2.43],
        [-73.07, -2.3],
        [-73.65, -1.26],
        [-74.12, -1.0],
        [-74.44, -0.53],
        [-75.1, -0.05],
        [-75.37, -0.15],
        [-75.8, 0.08],
        [-76.29, 0.41],
        [-76.57, 0.25],
        [-77.42, 0.39],
        [-77.66, 0.82],
        [-77.85, 0.8],
        [-78.85, 1.38],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-75.37, -0.15],
        [-75.23, -0.91],
        [-75.54, -1.56],
        [-76.63, -2.6],
        [-77.83, -3.0],
        [-78.45, -3.87],
        [-78.63, -4.54],
        [-79.2, -4.95],
        [-79.62, -4.45],
        [-80.02, -4.34],
        [-80.44, -4.42],
        [-80.46, -4.05],
        [-80.18, -3.82],
        [-80.3, -3.4],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-69.52, -10.95],
        [-70.09, -11.12],
        [-70.54, -11.0],
        [-70.48, -9.49],
        [-71.3, -10.07],
        [-72.18, -10.05],
        [-72.56, -9.52],
        [-73.22, -9.46],
        [-73.01, -9.03],
        [-73.57, -8.42],
        [-73.98, -7.52],
        [-73.72, -7.34],
        [-73.72, -6.91],
        [-73.12, -6.62],
        [-73.21, -6.08],
        [-72.96, -5.74],
        [-72.89, -5.27],
        [-71.74, -4.59],
        [-70.92, -4.4],
        [-70.79, -4.25],
        [-69.89, -4.29],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[-66.95, -54.89], [-67.56, -54.87], [-68.63, -54.86], [-68.63, -52.63]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-68.63, -52.29],
        [-69.49, -52.14],
        [-71.91, -52.0],
        [-72.32, -51.42],
        [-72.3, -50.67],
        [-72.97, -50.74],
        [-73.32, -50.37],
        [-73.41, -49.31],
        [-72.64, -48.87],
        [-72.33, -48.24],
        [-72.44, -47.73],
        [-71.91, -46.88],
        [-71.55, -45.56],
        [-71.65, -44.97],
        [-71.22, -44.78],
        [-71.32, -44.4],
        [-71.79, -44.2],
        [-71.46, -43.78],
        [-71.91, -43.4],
        [-72.14, -42.25],
        [-71.74, -42.05],
        [-71.91, -40.83],
        [-71.68, -39.8],
        [-71.41, -38.91],
        [-70.81, -38.55],
        [-71.11, -37.57],
        [-71.12, -36.65],
        [-70.36, -36.0],
        [-70.38, -35.16],
        [-69.81, -34.19],
        [-69.81, -33.27],
        [-70.07, -33.09],
        [-70.53, -31.36],
        [-69.91, -30.33],
        [-70.01, -29.36],
        [-69.65, -28.45],
        [-69.0, -27.52],
        [-68.29, -26.89],
        [-68.59, -26.5],
        [-68.38, -26.18],
        [-68.41, -24.51],
        [-67.32, -24.02],
        [-66.98, -22.98],
        [-67.1, -22.73],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-58.42, -33.9],
        [-58.34, -33.26],
        [-58.13, -33.04],
        [-58.14, -32.04],
        [-57.87, -31.01],
        [-57.62, -30.21],
        [-56.97, -30.1],
        [-55.97, -30.88],
        [-55.6, -30.85],
        [-54.57, -31.49],
        [-53.78, -32.04],
        [-53.2, -32.72],
        [-53.65, -33.2],
        [-53.37, -33.76],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-54.62, -25.73],
        [-54.78, -26.62],
        [-55.69, -27.38],
        [-56.48, -27.54],
        [-57.6, -27.39],
        [-58.61, -27.12],
        [-57.63, -25.6],
        [-57.77, -25.16],
        [-58.8, -24.77],
        [-60.02, -24.03],
        [-60.84, -23.88],
        [-62.68, -22.24],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-57.85, -19.97],
        [-58.16, -20.17],
        [-57.87, -20.73],
        [-57.93, -22.09],
        [-56.88, -22.28],
        [-56.47, -22.08],
        [-55.79, -22.35],
        [-55.61, -22.65],
        [-55.51, -23.57],
        [-55.4, -23.95],
        [-55.02, -24.0],
        [-54.65, -23.83],
        [-54.29, -24.02],
        [-54.29, -24.57],
        [-54.42, -25.16],
        [-54.62, -25.73],
        [-54.13, -25.54],
        [-53.62, -26.12],
        [-53.64, -26.92],
        [-54.49, -27.47],
        [-55.16, -27.88],
        [-56.29, -28.85],
        [-57.62, -30.21],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-59.75, 8.36],
        [-60.55, 7.77],
        [-60.63, 7.41],
        [-60.29, 7.04],
        [-60.54, 6.85],
        [-61.15, 6.69],
        [-61.13, 6.23],
        [-61.41, 5.95],
        [-60.73, 5.2],
        [-60.6, 4.91],
        [-60.96, 4.53],
        [-62.08, 4.16],
        [-62.8, 4.0],
        [-63.09, 3.77],
        [-63.88, 4.02],
        [-64.62, 4.14],
        [-64.81, 4.05],
        [-64.36, 3.79],
        [-64.4, 3.12],
        [-64.2, 2.49],
        [-63.42, 2.41],
        [-63.36, 2.2],
        [-64.08, 1.91],
        [-64.19, 1.49],
        [-64.61, 1.32],
        [-65.35, 1.09],
        [-65.54, 0.78],
        [-66.32, 0.72],
        [-66.87, 1.25],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-56.53, 1.89],
        [-56.78, 1.86],
        [-57.33, 1.94],
        [-57.66, 1.68],
        [-58.11, 1.5],
        [-58.42, 1.46],
        [-58.54, 1.26],
        [-59.03, 1.31],
        [-59.64, 1.78],
        [-59.71, 2.24],
        [-59.97, 2.75],
        [-59.81, 3.6],
        [-59.53, 3.95],
        [-59.76, 4.42],
        [-60.11, 4.57],
        [-59.98, 5.01],
        [-60.21, 5.24],
        [-60.73, 5.2],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-54.52, 2.31],
        [-55.09, 2.52],
        [-55.56, 2.42],
        [-55.97, 2.51],
        [-56.07, 2.22],
        [-55.9, 2.02],
        [-55.99, 1.81],
        [-56.53, 1.89],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-51.65, 4.15],
        [-52.24, 3.24],
        [-52.55, 2.5],
        [-52.93, 2.12],
        [-53.41, 2.05],
        [-53.55, 2.33],
        [-53.77, 2.37],
        [-54.08, 2.1],
        [-54.52, 2.31],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[115.45, 5.44], [115.4, 4.95], [115.34, 4.31], [114.86, 4.34], [114.65, 4.0], [114.2, 4.52]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [46.14, 38.74],
        [45.45, 38.87],
        [44.95, 39.33],
        [44.79, 39.71],
        [45.0, 39.7],
        [45.29, 39.47],
        [45.7, 39.47],
        [45.73, 39.31],
        [46.14, 38.74],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[-6.19, 53.86], [-6.95, 54.07], [-7.57, 54.05], [-7.36, 54.59], [-7.57, 55.13]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-16.71, 13.59],
        [-15.62, 13.62],
        [-15.39, 13.86],
        [-15.08, 13.87],
        [-14.68, 13.63],
        [-14.37, 13.62],
        [-14.04, 13.79],
        [-13.84, 13.5],
        [-14.27, 13.28],
        [-14.71, 13.29],
        [-15.14, 13.5],
        [-15.51, 13.27],
        [-15.69, 13.27],
        [-15.93, 13.13],
        [-16.84, 13.15],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[35.54, 32.39], [35.54, 31.78], [35.39, 31.48]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [28.97, -28.95],
        [29.32, -29.25],
        [29.01, -29.74],
        [28.84, -30.07],
        [28.29, -30.22],
        [28.1, -30.54],
        [27.74, -30.64],
        [26.99, -29.87],
        [27.53, -29.24],
        [28.07, -28.85],
        [28.54, -28.64],
        [28.97, -28.95],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-8.66, 27.65],
        [-8.66, 27.58],
        [-8.68, 27.39],
        [-8.68, 25.88],
        [-11.96, 25.93],
        [-11.93, 23.37],
        [-12.87, 23.28],
        [-13.11, 22.77],
        [-12.92, 21.32],
        [-16.84, 21.33],
        [-17.06, 20.99],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-8.68, 27.39],
        [-4.92, 24.97],
        [-6.45, 24.95],
        [-5.97, 20.64],
        [-5.48, 16.32],
        [-5.31, 16.2],
        [-5.53, 15.5],
        [-9.55, 15.48],
        [-9.7, 15.26],
        [-10.08, 15.33],
        [-10.65, 15.13],
        [-11.34, 15.41],
        [-11.66, 15.38],
        [-11.83, 14.79],
        [-12.17, 14.61],
        [-12.83, 15.3],
        [-13.43, 16.03],
        [-14.09, 16.3],
        [-14.57, 16.59],
        [-15.13, 16.58],
        [-15.62, 16.36],
        [-16.12, 16.45],
        [-16.46, 16.13],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-12.17, 14.61],
        [-12.12, 13.99],
        [-11.92, 13.42],
        [-11.55, 13.14],
        [-11.46, 12.75],
        [-11.51, 12.44],
        [-11.65, 12.38],
        [-12.2, 12.46],
        [-12.27, 12.35],
        [-12.49, 12.33],
        [-13.21, 12.57],
        [-13.7, 12.58],
        [-15.54, 12.62],
        [-15.81, 12.51],
        [-16.14, 12.54],
        [-16.67, 12.38],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-13.7, 12.58],
        [-13.71, 12.24],
        [-13.82, 12.14],
        [-13.74, 11.81],
        [-13.9, 11.67],
        [-14.12, 11.67],
        [-14.38, 11.5],
        [-14.68, 11.52],
        [-15.13, 11.04],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-11.51, 12.44],
        [-11.45, 12.07],
        [-11.29, 12.07],
        [-11.03, 12.21],
        [-10.87, 12.17],
        [-10.59, 11.92],
        [-10.16, 11.84],
        [-9.89, 12.06],
        [-9.56, 12.19],
        [-9.32, 12.33],
        [-9.12, 12.3],
        [-8.9, 12.08],
        [-8.78, 11.81],
        [-8.37, 11.39],
        [-8.58, 11.13],
        [-8.62, 10.81],
        [-8.4, 10.9],
        [-8.28, 10.79],
        [-8.33, 10.49],
        [-8.02, 10.2],
        [-8.22, 10.12],
        [-8.3, 9.78],
        [-8.07, 9.37],
        [-7.83, 8.57],
        [-8.2, 8.45],
        [-8.29, 8.31],
        [-8.22, 8.12],
        [-8.28, 7.68],
        [-8.43, 7.68],
        [-8.72, 7.71],
        [-8.92, 7.3],
        [-9.2, 7.31],
        [-9.4, 7.52],
        [-9.33, 7.92],
        [-9.75, 8.54],
        [-10.01, 8.42],
        [-10.23, 8.4],
        [-10.5, 8.34],
        [-10.49, 8.71],
        [-10.65, 8.97],
        [-10.62, 9.26],
        [-10.83, 9.68],
        [-11.11, 10.04],
        [-11.91, 10.04],
        [-12.15, 9.85],
        [-12.42, 9.83],
        [-12.59, 9.62],
        [-12.71, 9.34],
        [-13.24, 8.9],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[-11.43, 6.78], [-11.19, 7.1], [-11.14, 7.39], [-10.69, 7.93], [-10.23, 8.4]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-8.43, 7.68],
        [-8.48, 7.39],
        [-8.38, 6.91],
        [-8.6, 6.46],
        [-8.31, 6.19],
        [-7.99, 6.12],
        [-7.57, 5.7],
        [-7.53, 5.31],
        [-7.63, 5.18],
        [-7.71, 4.36],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [8.42, 36.94],
        [8.21, 36.43],
        [8.37, 35.47],
        [8.14, 34.65],
        [7.52, 34.09],
        [7.61, 33.34],
        [8.43, 32.74],
        [8.43, 32.5],
        [9.05, 32.1],
        [9.48, 30.3],
        [9.8, 29.42],
        [9.8, 28.9],
        [9.68, 28.14],
        [9.75, 27.68],
        [9.62, 27.14],
        [9.71, 26.51],
        [9.31, 26.09],
        [9.91, 25.36],
        [9.94, 24.93],
        [10.3, 24.37],
        [10.77, 24.56],
        [11.56, 24.09],
        [11.99, 23.47],
        [8.57, 21.56],
        [5.67, 19.6],
        [4.26, 19.15],
        [3.15, 19.05],
        [3.14, 19.69],
        [2.68, 19.85],
        [2.06, 20.14],
        [1.82, 20.61],
        [-1.55, 22.79],
        [-4.92, 24.97],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [11.48, 33.13],
        [11.43, 32.36],
        [10.94, 32.08],
        [10.63, 31.76],
        [9.95, 31.37],
        [10.05, 30.96],
        [9.97, 30.53],
        [9.48, 30.3],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [25.16, 31.56],
        [24.8, 31.08],
        [24.95, 30.66],
        [24.7, 30.04],
        [25, 29.23],
        [25, 25.68],
        [25, 22],
        [25, 20.0],
        [23.8, 20],
        [23.83, 19.58],
        [19.84, 21.49],
        [15.86, 23.4],
        [14.85, 22.86],
        [14.14, 22.49],
        [13.58, 23.04],
        [11.99, 23.47],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [4.26, 19.15],
        [4.27, 16.85],
        [3.72, 16.18],
        [3.63, 15.56],
        [2.75, 15.4],
        [1.38, 15.32],
        [1.01, 14.96],
        [0.37, 14.92],
        [-0.26, 14.92],
        [-0.51, 15.11],
        [-1.06, 14.97],
        [-2.0, 14.55],
        [-2.19, 14.24],
        [-2.96, 13.79],
        [-3.1, 13.54],
        [-3.52, 13.33],
        [-4.0, 13.47],
        [-4.28, 13.22],
        [-4.42, 12.54],
        [-5.22, 11.71],
        [-5.19, 11.37],
        [-5.47, 10.95],
        [-5.4, 10.37],
        [-5.81, 10.22],
        [-6.05, 10.09],
        [-6.2, 10.52],
        [-6.49, 10.41],
        [-6.66, 10.43],
        [-6.85, 10.13],
        [-7.62, 10.14],
        [-7.89, 10.29],
        [-8.02, 10.2],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [0.37, 14.92],
        [0.29, 14.44],
        [0.42, 13.98],
        [0.99, 13.33],
        [1.02, 12.85],
        [2.17, 12.62],
        [2.15, 11.94],
        [1.93, 11.64],
        [1.44, 11.54],
        [1.24, 11.11],
        [0.89, 10.99],
        [0.02, 11.01],
        [-0.43, 11.09],
        [-0.76, 10.93],
        [-1.2, 11.0],
        [-2.94, 10.96],
        [-2.96, 10.39],
        [-2.82, 9.64],
        [-3.51, 9.9],
        [-3.98, 9.86],
        [-4.33, 9.61],
        [-4.77, 9.82],
        [-4.95, 10.15],
        [-5.4, 10.37],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[-2.85, 4.99], [-2.81, 5.38], [-3.24, 6.25], [-2.98, 7.37], [-2.56, 8.21], [-2.82, 9.64]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [1.06, 5.92],
        [0.83, 6.27],
        [0.57, 6.91],
        [0.49, 7.41],
        [0.71, 8.31],
        [0.46, 8.67],
        [0.36, 9.46],
        [0.36, 10.19],
        [-0.04, 10.7],
        [0.02, 11.01],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[0.89, 10.99], [0.77, 10.47], [1.07, 10.17], [1.42, 9.82], [1.46, 9.33], [1.66, 9.12], [1.61, 6.83], [1.86, 6.14]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [2.15, 11.94],
        [2.49, 12.23],
        [2.84, 12.23],
        [3.61, 11.66],
        [3.57, 11.32],
        [3.79, 10.73],
        [3.6, 10.33],
        [3.7, 10.06],
        [3.22, 9.44],
        [2.91, 9.13],
        [2.72, 8.5],
        [2.74, 7.87],
        [2.69, 6.25],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [3.61, 11.66],
        [3.68, 12.55],
        [3.96, 12.95],
        [4.1, 13.53],
        [4.36, 13.74],
        [5.44, 13.86],
        [6.44, 13.49],
        [6.82, 13.11],
        [7.33, 13.09],
        [7.8, 13.34],
        [9.01, 12.82],
        [9.52, 12.85],
        [10.11, 13.27],
        [10.7, 13.24],
        [10.98, 13.38],
        [11.52, 13.32],
        [12.3, 13.03],
        [13.08, 13.59],
        [13.31, 13.55],
        [13.99, 12.46],
        [14.18, 12.48],
        [14.57, 12.08],
        [14.46, 11.9],
        [14.41, 11.57],
        [13.57, 10.79],
        [13.3, 10.16],
        [13.16, 9.64],
        [12.95, 9.41],
        [12.75, 8.71],
        [12.21, 8.3],
        [12.06, 7.79],
        [11.83, 7.39],
        [11.74, 6.98],
        [11.05, 6.64],
        [10.49, 7.05],
        [10.11, 7.03],
        [9.52, 6.45],
        [9.23, 6.44],
        [8.75, 5.47],
        [8.5, 4.77],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[36.86, 22], [32.9, 22], [29.0, 22], [25, 22]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [14.85, 22.86],
        [15.09, 21.3],
        [15.47, 21.04],
        [15.48, 20.73],
        [15.9, 20.38],
        [15.68, 19.95],
        [15.3, 17.92],
        [15.24, 16.62],
        [13.97, 15.68],
        [13.54, 14.36],
        [13.95, 13.99],
        [13.95, 13.35],
        [14.59, 13.33],
        [14.49, 12.85],
        [14.21, 12.8],
        [14.18, 12.48],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [23.83, 19.58],
        [23.88, 15.61],
        [23.02, 15.68],
        [22.56, 14.94],
        [22.3, 14.32],
        [22.51, 14.09],
        [22.18, 13.78],
        [22.29, 13.37],
        [22.03, 12.95],
        [21.93, 12.58],
        [22.28, 12.64],
        [22.49, 12.26],
        [22.5, 11.67],
        [22.87, 11.38],
        [22.86, 11.14],
        [22.23, 10.97],
        [21.72, 10.56],
        [21.0, 9.47],
        [20.05, 9.01],
        [19.09, 9.07],
        [18.81, 8.98],
        [18.91, 8.63],
        [18.38, 8.28],
        [17.96, 7.89],
        [16.7, 7.5],
        [16.45, 7.73],
        [16.29, 7.75],
        [16.1, 7.49],
        [15.27, 7.42],
        [15.43, 7.69],
        [15.12, 8.38],
        [14.98, 8.79],
        [14.54, 8.96],
        [13.95, 9.54],
        [14.17, 10.02],
        [14.62, 9.92],
        [14.9, 9.99],
        [15.46, 9.98],
        [14.92, 10.89],
        [14.96, 11.55],
        [14.89, 12.21],
        [14.49, 12.85],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [15.27, 7.42],
        [14.77, 6.4],
        [14.53, 6.22],
        [14.45, 5.45],
        [14.55, 5.03],
        [14.47, 4.73],
        [14.95, 4.21],
        [15.03, 3.85],
        [15.4, 3.33],
        [15.86, 3.01],
        [15.9, 2.55],
        [16.01, 2.26],
        [15.94, 1.72],
        [15.14, 1.96],
        [14.33, 2.22],
        [13.07, 2.26],
        [12.95, 2.32],
        [12.35, 2.19],
        [11.75, 2.32],
        [11.27, 2.26],
        [9.64, 2.28],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[11.27, 2.26], [11.28, 1.05], [9.83, 1.06], [9.49, 1.01]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [13.07, 2.26],
        [13.0, 1.83],
        [13.28, 1.31],
        [14.02, 1.39],
        [14.27, 1.19],
        [13.84, 0.03],
        [14.31, -0.55],
        [14.42, -1.33],
        [14.29, -1.99],
        [13.99, -2.47],
        [13.1, -2.42],
        [12.57, -1.94],
        [12.49, -2.39],
        [11.82, -2.51],
        [11.47, -2.76],
        [11.85, -3.42],
        [11.09, -3.97],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [16.01, 2.26],
        [16.53, 3.19],
        [17.13, 3.72],
        [17.8, 3.56],
        [18.45, 3.5],
        [18.39, 2.9],
        [18.09, 2.36],
        [17.89, 1.74],
        [17.77, 0.85],
        [17.82, 0.28],
        [17.66, -0.05],
        [17.63, -0.42],
        [17.52, -0.74],
        [16.86, -1.22],
        [16.4, -1.74],
        [15.97, -2.71],
        [16.0, -3.53],
        [15.75, -3.85],
        [15.17, -4.34],
        [14.58, -4.97],
        [14.2, -4.79],
        [14.14, -4.5],
        [13.6, -4.5],
        [13.25, -4.88],
        [12.99, -4.78],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [22.86, 11.14],
        [22.97, 10.71],
        [23.55, 10.08],
        [23.55, 9.68],
        [23.39, 9.26],
        [23.45, 8.95],
        [23.8, 8.66],
        [24.56, 8.22],
        [25.11, 7.82],
        [25.12, 7.5],
        [25.79, 6.97],
        [26.21, 6.54],
        [26.46, 5.94],
        [27.21, 5.55],
        [27.37, 5.23],
        [27.04, 5.12],
        [26.4, 5.15],
        [25.65, 5.25],
        [25.27, 5.17],
        [25.12, 4.92],
        [24.8, 4.89],
        [24.41, 5.1],
        [23.29, 4.6],
        [22.84, 4.71],
        [22.7, 4.63],
        [22.4, 4.02],
        [21.65, 4.22],
        [20.92, 4.32],
        [20.29, 4.69],
        [19.46, 5.03],
        [18.93, 4.7],
        [18.54, 4.2],
        [18.45, 3.5],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [36.42, 14.42],
        [37.59, 14.21],
        [37.9, 14.95],
        [38.51, 14.5],
        [39.09, 14.74],
        [39.34, 14.53],
        [40.02, 14.51],
        [40.89, 14.11],
        [41.15, 13.77],
        [41.59, 13.45],
        [42.0, 12.86],
        [42.35, 12.54],
        [42.77, 12.45],
        [43.08, 12.69],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [43.14, 11.46],
        [42.77, 10.92],
        [42.55, 11.1],
        [42.31, 11.03],
        [41.75, 11.05],
        [41.73, 11.35],
        [41.66, 11.63],
        [42, 12.1],
        [42.35, 12.54],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[29.57, -1.34], [29.82, -1.44], [30.41, -1.13], [30.76, -1.01], [31.86, -1.02], [33.9, -0.9]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[30.41, -1.13], [30.81, -1.69], [30.75, -2.28], [30.46, -2.41], [29.93, -2.34], [29.63, -2.91], [29.02, -2.83]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [23.91, -10.92],
        [24.01, -11.23],
        [23.9, -11.72],
        [24.07, -12.19],
        [23.93, -12.56],
        [24.01, -12.91],
        [21.93, -12.89],
        [21.88, -16.08],
        [22.56, -16.89],
        [23.21, -17.52],
        [21.37, -17.93],
        [18.95, -17.78],
        [18.26, -17.3],
        [14.2, -17.35],
        [14.05, -17.42],
        [13.46, -16.97],
        [12.81, -16.94],
        [12.21, -17.11],
        [11.73, -17.3],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [23.21, -17.52],
        [24.03, -17.29],
        [24.68, -17.35],
        [25.07, -17.57],
        [25.08, -17.66],
        [24.52, -17.88],
        [24.21, -17.88],
        [23.57, -18.28],
        [23.19, -17.86],
        [21.65, -18.21],
        [20.91, -18.25],
        [20.88, -21.81],
        [19.89, -21.84],
        [19.89, -24.76],
        [19.89, -28.46],
        [19.0, -28.97],
        [18.46, -29.04],
        [17.83, -28.85],
        [17.38, -28.78],
        [17.21, -28.35],
        [16.82, -28.08],
        [16.34, -28.57],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [32.07, -26.73],
        [31.86, -27.17],
        [31.28, -27.28],
        [30.68, -26.74],
        [30.67, -26.39],
        [30.94, -26.02],
        [31.04, -25.73],
        [31.33, -25.66],
        [31.83, -25.84],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [25.26, -17.73],
        [25.64, -18.53],
        [25.85, -18.71],
        [26.16, -19.29],
        [27.29, -20.39],
        [27.72, -20.49],
        [27.72, -20.85],
        [28.02, -21.48],
        [28.79, -21.63],
        [29.43, -22.09],
        [28.01, -22.82],
        [27.11, -23.57],
        [26.78, -24.24],
        [26.48, -24.61],
        [25.94, -24.69],
        [25.76, -25.17],
        [25.66, -25.48],
        [25.02, -25.71],
        [24.21, -25.67],
        [23.73, -25.39],
        [23.31, -25.26],
        [22.82, -25.5],
        [22.57, -25.97],
        [22.1, -26.28],
        [21.6, -26.72],
        [20.88, -26.82],
        [20.66, -26.47],
        [20.75, -25.86],
        [20.16, -24.91],
        [19.89, -24.76],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [30.27, -15.5],
        [30.33, -15.88],
        [31.17, -15.86],
        [31.63, -16.07],
        [31.85, -16.31],
        [32.32, -16.39],
        [32.84, -16.71],
        [32.84, -17.97],
        [32.65, -18.67],
        [32.61, -19.41],
        [32.77, -19.71],
        [32.65, -20.3],
        [32.5, -20.39],
        [32.24, -21.11],
        [31.19, -22.25],
        [30.65, -22.15],
        [30.32, -22.27],
        [29.83, -22.1],
        [29.43, -22.09],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [32.83, -26.74],
        [32.07, -26.73],
        [31.98, -26.29],
        [31.83, -25.84],
        [31.75, -25.48],
        [31.93, -24.36],
        [31.67, -23.65],
        [31.19, -22.25],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-9.03, 41.88],
        [-8.67, 42.13],
        [-8.26, 42.28],
        [-8.01, 41.79],
        [-7.42, 41.79],
        [-7.25, 41.91],
        [-6.66, 41.88],
        [-6.38, 41.38],
        [-6.85, 41.11],
        [-6.86, 40.33],
        [-7.02, 40.18],
        [-7.06, 39.71],
        [-7.49, 39.62],
        [-7.09, 39.03],
        [-7.37, 38.37],
        [-7.02, 38.07],
        [-7.16, 37.8],
        [-7.53, 37.42],
        [-7.45, 37.09],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[2.98, 42.47], [1.82, 42.34], [0.7, 42.79], [0.33, 42.57], [-1.5, 43.03], [-1.9, 43.42]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[9.92, 54.98], [9.28, 54.83], [8.52, 54.96]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [6.18, 49.46],
        [6.65, 49.2],
        [8.09, 49.01],
        [7.59, 48.33],
        [7.46, 47.62],
        [7.19, 47.44],
        [6.73, 47.54],
        [6.76, 47.28],
        [6.03, 46.72],
        [6.02, 46.27],
        [6.5, 46.42],
        [6.84, 45.99],
        [6.8, 45.7],
        [7.09, 45.33],
        [6.74, 45.02],
        [7.0, 44.25],
        [7.54, 44.12],
        [7.43, 43.69],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [14.11, 53.75],
        [14.35, 53.24],
        [14.07, 52.98],
        [14.43, 52.62],
        [14.68, 52.08],
        [14.6, 51.74],
        [15.01, 51.1],
        [14.57, 51.0],
        [14.3, 51.11],
        [14.05, 50.92],
        [13.33, 50.73],
        [12.96, 50.48],
        [12.24, 50.26],
        [12.41, 49.96],
        [12.52, 49.54],
        [13.03, 49.3],
        [13.59, 48.87],
        [13.24, 48.41],
        [12.88, 48.28],
        [13.02, 47.63],
        [12.93, 47.46],
        [12.62, 47.67],
        [12.14, 47.7],
        [11.42, 47.52],
        [10.54, 47.56],
        [10.4, 47.3],
        [9.89, 47.58],
        [9.59, 47.52],
        [8.52, 47.83],
        [8.31, 47.61],
        [7.46, 47.62],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [9.59, 47.52],
        [9.63, 47.34],
        [9.47, 47.1],
        [9.93, 46.92],
        [10.44, 46.89],
        [10.36, 46.48],
        [9.92, 46.31],
        [9.18, 46.44],
        [8.96, 46.03],
        [8.48, 46.0],
        [8.31, 46.16],
        [7.75, 45.82],
        [7.27, 45.77],
        [6.84, 45.99],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [10.44, 46.89],
        [11.04, 46.75],
        [11.16, 46.94],
        [12.15, 47.11],
        [12.37, 46.76],
        [13.8, 46.5],
        [13.69, 46.01],
        [13.93, 45.59],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [19.66, 54.42],
        [20.89, 54.31],
        [22.73, 54.32],
        [23.24, 54.22],
        [23.48, 53.91],
        [23.52, 53.47],
        [23.8, 53.08],
        [23.79, 52.69],
        [23.19, 52.48],
        [23.5, 52.02],
        [23.52, 51.57],
        [24.02, 50.7],
        [23.92, 50.42],
        [23.42, 50.3],
        [22.51, 49.47],
        [22.77, 49.02],
        [22.55, 49.08],
        [21.6, 49.47],
        [20.88, 49.32],
        [20.41, 49.43],
        [19.82, 49.21],
        [19.32, 49.57],
        [18.9, 49.43],
        [18.85, 49.49],
        [18.39, 49.98],
        [17.64, 50.04],
        [17.55, 50.36],
        [16.86, 50.47],
        [16.71, 50.21],
        [16.17, 50.42],
        [16.23, 50.69],
        [15.49, 50.78],
        [15.01, 51.1],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [24.31, 57.79],
        [25.16, 57.97],
        [25.6, 57.84],
        [26.46, 57.47],
        [27.28, 57.47],
        [27.77, 57.24],
        [27.85, 56.75],
        [28.17, 56.16],
        [27.1, 55.78],
        [26.49, 55.61],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[27.98, 59.47], [28.13, 59.3], [27.42, 58.72], [27.71, 57.79], [27.28, 57.47]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [28.17, 56.16],
        [29.22, 55.91],
        [29.37, 55.67],
        [29.89, 55.78],
        [30.87, 55.55],
        [30.97, 55.08],
        [30.75, 54.81],
        [31.38, 54.15],
        [31.79, 53.97],
        [31.73, 53.79],
        [32.4, 53.61],
        [32.69, 53.35],
        [32.3, 53.13],
        [31.49, 53.16],
        [31.3, 53.07],
        [31.5, 52.74],
        [31.78, 52.1],
        [30.92, 52.04],
        [30.61, 51.82],
        [30.55, 51.31],
        [30.15, 51.41],
        [29.25, 51.36],
        [28.99, 51.6],
        [28.61, 51.42],
        [28.24, 51.57],
        [27.45, 51.59],
        [26.33, 51.83],
        [25.32, 51.91],
        [24.55, 51.88],
        [24.0, 51.61],
        [23.52, 51.57],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [6.9, 53.48],
        [7.09, 53.14],
        [6.84, 52.22],
        [6.58, 51.85],
        [5.98, 51.85],
        [6.15, 50.8],
        [5.6, 51.03],
        [4.97, 51.47],
        [4.04, 51.26],
        [3.31, 51.34],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [6.15, 50.8],
        [6.04, 50.12],
        [5.78, 50.09],
        [5.67, 49.52],
        [4.79, 49.98],
        [4.28, 49.9],
        [3.58, 50.37],
        [3.12, 50.78],
        [2.65, 50.79],
        [2.51, 51.14],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[6.04, 50.12], [6.24, 49.9], [6.18, 49.46], [5.89, 49.44], [5.67, 49.52]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[21.26, 55.19], [22.31, 55.01], [22.75, 54.85], [22.65, 54.58], [22.73, 54.32]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [21.05, 56.03],
        [22.2, 56.33],
        [23.87, 56.27],
        [24.86, 56.37],
        [25.0, 56.16],
        [25.53, 56.1],
        [26.49, 55.61],
        [26.58, 55.16],
        [25.76, 54.84],
        [25.53, 54.28],
        [24.45, 53.9],
        [23.48, 53.91],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [18.85, 49.49],
        [18.55, 49.49],
        [18.4, 49.31],
        [18.17, 49.27],
        [18.1, 49.04],
        [17.91, 48.99],
        [17.88, 48.9],
        [17.54, 48.8],
        [17.1, 48.81],
        [16.96, 48.59],
        [16.49, 48.78],
        [16.02, 48.73],
        [15.25, 49.03],
        [14.9, 48.96],
        [14.33, 48.55],
        [13.59, 48.87],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [16.96, 48.59],
        [16.8, 48.4],
        [16.97, 48.12],
        [16.9, 47.71],
        [16.34, 47.71],
        [16.53, 47.49],
        [16.2, 46.85],
        [16.01, 46.68],
        [15.13, 46.65],
        [14.63, 46.43],
        [13.8, 46.5],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [22.08, 48.42],
        [22.64, 48.15],
        [22.71, 47.88],
        [22.09, 47.67],
        [21.62, 46.99],
        [21.02, 46.31],
        [20.22, 46.12],
        [19.59, 46.17],
        [18.82, 45.9],
        [18.45, 45.75],
        [17.63, 45.95],
        [16.88, 46.38],
        [16.56, 46.5],
        [16.37, 46.84],
        [16.2, 46.85],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [18.4, 42.4],
        [18.5, 42.6],
        [17.67, 43.02],
        [17.29, 43.44],
        [16.91, 43.66],
        [16.45, 44.04],
        [16.23, 44.35],
        [15.75, 44.81],
        [15.95, 45.23],
        [16.31, 45.0],
        [16.53, 45.21],
        [17.0, 45.23],
        [17.86, 45.06],
        [18.55, 45.08],
        [19.0, 44.86],
        [19.39, 45.23],
        [19.07, 45.52],
        [18.82, 45.9],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [22.55, 49.08],
        [22.28, 48.82],
        [22.08, 48.42],
        [21.87, 48.31],
        [20.8, 48.62],
        [20.47, 48.56],
        [20.23, 48.32],
        [19.76, 48.2],
        [19.66, 48.26],
        [19.17, 48.11],
        [18.77, 48.08],
        [18.69, 47.88],
        [17.85, 47.75],
        [17.48, 47.86],
        [16.97, 48.12],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [16.56, 46.5],
        [15.76, 46.23],
        [15.67, 45.83],
        [15.32, 45.73],
        [15.32, 45.45],
        [14.93, 45.47],
        [14.59, 45.63],
        [14.41, 45.46],
        [13.71, 45.5],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [26.61, 48.22],
        [26.92, 48.12],
        [27.23, 47.82],
        [27.55, 47.4],
        [28.12, 46.81],
        [28.1, 46.37],
        [28.05, 45.94],
        [28.23, 45.48],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [28.55, 43.7],
        [27.97, 43.81],
        [27.24, 44.17],
        [26.06, 43.94],
        [25.56, 43.68],
        [24.1, 43.74],
        [23.33, 43.89],
        [22.94, 43.82],
        [22.65, 44.23],
        [22.47, 44.4],
        [22.7, 44.57],
        [22.45, 44.7],
        [22.14, 44.47],
        [21.56, 44.76],
        [21.48, 45.18],
        [20.87, 45.41],
        [20.76, 45.73],
        [20.22, 46.12],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [22.65, 44.23],
        [22.41, 44.0],
        [22.5, 43.64],
        [22.98, 43.21],
        [22.6, 42.89],
        [22.43, 42.58],
        [22.54, 42.46],
        [22.38, 42.32],
        [21.91, 42.3],
        [21.57, 42.24],
        [21.35, 42.2],
        [20.76, 42.05],
        [20.71, 41.84],
        [20.59, 41.85],
        [20.52, 42.21],
        [20.28, 42.32],
        [20.07, 42.58],
        [19.8, 42.5],
        [19.73, 42.68],
        [19.3, 42.19],
        [19.37, 41.87],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [22.71, 47.88],
        [23.14, 48.09],
        [23.76, 47.98],
        [24.4, 47.98],
        [24.86, 47.73],
        [25.2, 47.89],
        [25.94, 47.98],
        [26.19, 48.22],
        [26.61, 48.22],
        [26.85, 48.36],
        [27.52, 48.46],
        [28.25, 48.15],
        [28.67, 48.11],
        [29.12, 47.84],
        [29.05, 47.51],
        [29.41, 47.34],
        [29.55, 46.92],
        [29.9, 46.67],
        [29.83, 46.52],
        [30.02, 46.42],
        [29.7, 46.3],
        [29.17, 46.37],
        [29.07, 46.51],
        [28.86, 46.43],
        [28.93, 46.25],
        [28.6, 45.9],
        [28.48, 45.59],
        [28.23, 45.48],
        [28.67, 45.3],
        [29.14, 45.46],
        [29.6, 45.29],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [31.78, 52.1],
        [32.15, 52.06],
        [32.41, 52.28],
        [32.71, 52.23],
        [33.75, 52.33],
        [34.39, 51.76],
        [34.14, 51.56],
        [34.22, 51.25],
        [35.02, 51.2],
        [35.37, 50.77],
        [35.35, 50.57],
        [36.62, 50.22],
        [37.39, 50.38],
        [38.01, 49.91],
        [38.59, 49.92],
        [40.06, 49.6],
        [40.08, 49.3],
        [39.67, 48.78],
        [39.89, 48.23],
        [39.73, 47.89],
        [38.77, 47.82],
        [38.25, 47.54],
        [38.22, 47.1],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [27.99, 42.0],
        [27.13, 42.14],
        [26.11, 41.82],
        [26.1, 41.32],
        [25.19, 41.23],
        [24.49, 41.58],
        [23.69, 41.3],
        [22.95, 41.33],
        [22.88, 41.99],
        [22.38, 42.32],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [22.95, 41.33],
        [22.76, 41.3],
        [22.59, 41.13],
        [22.05, 41.14],
        [21.67, 40.93],
        [21.02, 40.84],
        [20.6, 41.08],
        [20.46, 41.51],
        [20.59, 41.85],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[26.11, 41.82], [26.6, 41.56], [26.29, 40.93], [26.05, 40.82]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[21.02, 40.84], [21, 40.5], [20.67, 40.43], [20.61, 40.1], [20.1, 39.62]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [41.55, 41.53],
        [42.61, 41.58],
        [43.58, 41.09],
        [43.75, 40.74],
        [43.65, 40.25],
        [44.4, 40.0],
        [44.79, 39.71],
        [44.1, 39.42],
        [44.42, 38.28],
        [44.22, 37.97],
        [44.77, 37.17],
        [44.29, 37.0],
        [43.94, 37.25],
        [42.77, 37.38],
        [42.34, 37.22],
        [41.21, 37.07],
        [40.67, 37.09],
        [39.52, 36.71],
        [38.69, 36.71],
        [38.16, 36.9],
        [37.06, 36.62],
        [36.73, 36.81],
        [36.68, 36.25],
        [36.41, 36.04],
        [36.14, 35.82],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [39.95, 43.43],
        [40.07, 43.55],
        [40.92, 43.38],
        [42.39, 43.22],
        [43.75, 42.74],
        [43.93, 42.55],
        [44.53, 42.71],
        [45.47, 42.5],
        [45.77, 42.09],
        [46.4, 41.86],
        [46.14, 41.72],
        [46.63, 41.18],
        [46.5, 41.06],
        [45.96, 41.12],
        [45.21, 41.41],
        [44.97, 41.24],
        [43.58, 41.09],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [28.59, 69.06],
        [28.44, 68.36],
        [29.97, 67.69],
        [29.05, 66.94],
        [30.21, 65.8],
        [29.54, 64.94],
        [30.44, 64.2],
        [30.03, 63.55],
        [31.51, 62.86],
        [31.14, 62.35],
        [30.21, 61.78],
        [28.0, 60.5],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[46.5, 38.77], [47.68, 39.5], [48.06, 39.58], [48.35, 39.28], [48.01, 38.79], [48.63, 38.27], [48.88, 38.32]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[35.39, 31.48], [35.42, 31.1], [34.92, 29.5]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [38.79, 33.37],
        [39.19, 32.16],
        [39.0, 32.01],
        [37.0, 31.5],
        [37.99, 30.5],
        [37.66, 30.33],
        [37.5, 30.0],
        [36.74, 29.86],
        [36.5, 29.5],
        [36.06, 29.19],
        [34.95, 29.35],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[47.97, 29.97], [47.3, 30.05], [46.56, 29.09], [44.7, 29.17], [41.8, 31.1], [40.4, 31.8], [39.19, 32.16]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [48.56, 29.92],
        [48.01, 30.45],
        [48.0, 30.98],
        [47.68, 30.98],
        [47.84, 31.7],
        [47.33, 32.46],
        [46.1, 33.01],
        [45.41, 33.96],
        [45.64, 34.74],
        [46.15, 35.09],
        [46.07, 35.67],
        [45.42, 35.97],
        [44.77, 37.17],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [53.92, 37.19],
        [54.8, 37.39],
        [55.51, 37.96],
        [56.18, 37.93],
        [56.61, 38.12],
        [57.33, 38.02],
        [58.43, 37.52],
        [59.23, 37.41],
        [60.37, 36.52],
        [61.12, 36.49],
        [61.21, 35.65],
        [60.8, 34.4],
        [60.52, 33.67],
        [60.96, 33.52],
        [60.53, 32.98],
        [60.86, 32.18],
        [60.94, 31.54],
        [61.69, 31.37],
        [61.78, 30.73],
        [60.87, 29.82],
        [61.36, 29.3],
        [61.77, 28.69],
        [62.72, 28.25],
        [62.75, 27.37],
        [63.23, 27.21],
        [63.31, 26.75],
        [61.87, 26.23],
        [61.49, 25.07],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[53.1, 16.65], [52.78, 17.34], [52, 19], [55, 20], [55.66, 22], [55.2, 22.7]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [42.77, 16.34],
        [43.21, 16.66],
        [43.11, 17.08],
        [43.38, 17.57],
        [43.79, 17.31],
        [44.06, 17.41],
        [45.21, 17.43],
        [45.4, 17.33],
        [46.36, 17.23],
        [46.7, 17.28],
        [47, 16.9],
        [47.46, 17.11],
        [48.18, 18.16],
        [49.11, 18.61],
        [52, 19],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[20.64, 69.1], [21.97, 68.61], [23.53, 67.93], [23.56, 66.39], [23.9, 66.0]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[48.41, 28.55], [47.7, 28.52], [47.45, 29.0], [46.56, 29.09]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[51.38, 24.62], [51.11, 24.55], [50.81, 24.75]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[56.07, 26.05], [56.26, 25.71]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [56.39, 24.92],
        [55.88, 24.92],
        [55.8, 24.26],
        [55.98, 24.13],
        [55.52, 23.93],
        [55.52, 23.52],
        [55.23, 23.11],
        [55.2, 22.7],
        [55.0, 22.49],
        [52.0, 23.0],
        [51.61, 24.01],
        [51.57, 24.24],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [49.1, 46.39],
        [48.59, 46.56],
        [48.69, 47.07],
        [48.05, 47.74],
        [47.31, 47.71],
        [46.46, 48.39],
        [47.04, 49.15],
        [46.75, 49.35],
        [47.54, 50.45],
        [48.57, 49.87],
        [48.7, 50.6],
        [50.76, 51.69],
        [52.32, 51.71],
        [54.53, 51.02],
        [55.71, 50.62],
        [56.77, 51.04],
        [58.36, 51.06],
        [59.64, 50.54],
        [59.93, 50.84],
        [61.33, 50.79],
        [61.58, 51.27],
        [59.96, 51.96],
        [60.92, 52.44],
        [60.7, 52.7],
        [61.7, 52.9],
        [60.97, 53.66],
        [61.43, 54.0],
        [65.17, 54.35],
        [65.66, 54.6],
        [68.16, 54.97],
        [69.06, 55.38],
        [70.86, 55.16],
        [71.18, 54.13],
        [72.22, 54.37],
        [73.5, 54.03],
        [73.42, 53.48],
        [74.38, 53.54],
        [76.89, 54.49],
        [76.52, 54.17],
        [77.8, 53.4],
        [80.03, 50.86],
        [80.56, 51.38],
        [81.94, 50.81],
        [83.38, 51.06],
        [83.93, 50.88],
        [84.41, 50.31],
        [85.11, 50.11],
        [85.54, 49.69],
        [86.82, 49.82],
        [87.3, 49.21],
        [86.59, 48.54],
        [85.76, 48.45],
        [85.72, 47.45],
        [85.16, 47.0],
        [83.18, 47.33],
        [82.45, 45.53],
        [81.94, 45.31],
        [79.96, 44.91],
        [80.86, 43.18],
        [80.18, 42.92],
        [80.2, 42.3],
        [79.64, 42.49],
        [79.14, 42.85],
        [77.65, 42.96],
        [76.0, 42.98],
        [75.63, 42.87],
        [74.21, 43.29],
        [73.64, 43.09],
        [73.48, 42.5],
        [71.84, 42.84],
        [71.18, 42.7],
        [70.96, 42.26],
        [70.38, 42.08],
        [69.07, 41.38],
        [68.63, 40.66],
        [68.25, 40.66],
        [67.98, 41.13],
        [66.71, 41.16],
        [66.51, 41.98],
        [66.02, 41.99],
        [66.09, 42.99],
        [64.9, 43.72],
        [63.18, 43.65],
        [62.01, 43.5],
        [61.05, 44.4],
        [60.2, 44.78],
        [58.6, 45.5],
        [58.5, 45.58],
        [55.92, 44.99],
        [55.96, 41.3],
        [55.45, 41.25],
        [54.75, 42.04],
        [54.07, 42.32],
        [52.94, 42.11],
        [52.5, 41.78],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [70.96, 42.26],
        [71.25, 42.16],
        [70.4, 41.5],
        [71.15, 41.14],
        [71.87, 41.39],
        [73.05, 40.86],
        [71.77, 40.14],
        [71.01, 40.24],
        [70.6, 40.21],
        [70.45, 40.49],
        [70.66, 40.96],
        [69.32, 40.72],
        [69.01, 40.08],
        [68.53, 39.53],
        [67.7, 39.58],
        [67.44, 39.14],
        [68.17, 38.9],
        [68.39, 38.15],
        [67.8, 37.14],
        [67.07, 37.35],
        [66.51, 37.36],
        [66.54, 37.97],
        [65.21, 38.4],
        [64.17, 38.89],
        [63.51, 39.36],
        [62.37, 40.05],
        [61.88, 41.08],
        [61.54, 41.26],
        [60.46, 41.22],
        [60.08, 41.42],
        [59.97, 42.22],
        [58.62, 42.75],
        [57.78, 42.17],
        [56.93, 41.82],
        [57.09, 41.32],
        [55.96, 41.3],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [66.51, 37.36],
        [66.21, 37.39],
        [65.74, 37.66],
        [65.58, 37.3],
        [64.74, 37.11],
        [64.54, 36.31],
        [63.98, 36.0],
        [63.19, 35.85],
        [62.98, 35.4],
        [62.23, 35.27],
        [61.21, 35.65],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [67.8, 37.14],
        [68.13, 37.02],
        [68.85, 37.34],
        [69.19, 37.15],
        [69.51, 37.6],
        [70.11, 37.58],
        [70.27, 37.73],
        [70.37, 38.13],
        [70.8, 38.48],
        [71.34, 38.25],
        [71.23, 37.95],
        [71.54, 37.9],
        [71.44, 37.06],
        [71.84, 36.73],
        [72.19, 36.94],
        [72.63, 37.04],
        [73.26, 37.49],
        [73.94, 37.42],
        [74.9, 37.4],
        [75.15, 37.13],
        [74.57, 37.02],
        [74.06, 36.83],
        [72.9, 36.7],
        [71.84, 36.5],
        [71.26, 36.07],
        [71.49, 35.65],
        [71.61, 35.15],
        [71.11, 34.73],
        [71.15, 34.34],
        [70.88, 33.98],
        [69.93, 34.02],
        [70.32, 33.35],
        [69.68, 33.1],
        [69.26, 32.5],
        [69.31, 31.9],
        [68.92, 31.62],
        [68.55, 31.71],
        [67.79, 31.58],
        [67.68, 31.3],
        [66.93, 31.3],
        [66.38, 30.73],
        [66.34, 29.88],
        [65.04, 29.47],
        [64.35, 29.56],
        [64.14, 29.34],
        [63.55, 29.46],
        [62.54, 29.31],
        [60.87, 29.82],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [80.2, 42.3],
        [80.11, 42.12],
        [78.54, 41.58],
        [78.18, 41.18],
        [76.9, 41.06],
        [76.52, 40.42],
        [75.46, 40.56],
        [74.77, 40.36],
        [73.82, 39.89],
        [73.9, 39.6],
        [73.67, 39.43],
        [71.78, 39.27],
        [70.54, 39.6],
        [69.46, 39.52],
        [69.55, 40.1],
        [70.64, 39.93],
        [71.01, 40.24],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[73.67, 39.43], [73.92, 38.5], [74.25, 38.6], [74.86, 38.37], [74.8, 37.9], [74.9, 37.4]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [74.45, 32.76],
        [75.25, 32.27],
        [74.4, 31.69],
        [74.42, 30.97],
        [73.45, 29.97],
        [72.82, 28.96],
        [71.77, 27.91],
        [70.61, 27.98],
        [69.51, 26.94],
        [70.16, 26.49],
        [70.28, 25.72],
        [70.84, 25.21],
        [71.04, 24.35],
        [68.84, 24.35],
        [68.17, 23.69],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [97.32, 28.26],
        [97.4, 27.88],
        [97.05, 27.69],
        [97.13, 27.08],
        [96.41, 27.26],
        [95.12, 26.57],
        [95.15, 26.0],
        [94.6, 25.16],
        [94.55, 24.67],
        [94.1, 23.85],
        [93.32, 24.07],
        [93.28, 23.04],
        [93.06, 22.7],
        [93.16, 22.27],
        [92.67, 22.04],
        [92.14, 23.62],
        [91.86, 23.62],
        [91.7, 22.98],
        [91.15, 23.5],
        [91.46, 24.07],
        [91.91, 24.13],
        [92.37, 24.97],
        [91.79, 25.14],
        [90.87, 25.13],
        [89.92, 25.26],
        [89.83, 25.96],
        [89.35, 26.01],
        [88.56, 26.44],
        [88.2, 25.76],
        [88.93, 25.23],
        [88.3, 24.86],
        [88.08, 24.5],
        [88.69, 24.23],
        [88.52, 23.63],
        [88.87, 22.87],
        [89.03, 22.05],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [88.12, 27.87],
        [86.95, 27.97],
        [85.82, 28.2],
        [85.01, 28.64],
        [84.23, 28.83],
        [83.89, 29.32],
        [83.33, 29.46],
        [82.32, 30.11],
        [81.52, 30.42],
        [81.11, 30.18],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[88.81, 27.29], [89.47, 28.04], [90.01, 28.29], [90.73, 28.06], [91.25, 28.04], [91.69, 27.77]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[92.36, 20.67], [92.3, 21.47], [92.65, 21.32], [92.67, 22.04]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [97.32, 28.26],
        [97.91, 28.33],
        [98.24, 27.74],
        [98.68, 27.5],
        [98.71, 26.74],
        [98.67, 25.91],
        [97.72, 25.08],
        [97.6, 23.89],
        [98.66, 24.06],
        [98.89, 23.14],
        [99.53, 22.94],
        [99.24, 22.11],
        [99.98, 21.74],
        [100.41, 21.55],
        [101.1, 21.8],
        [101.17, 21.43],
        [100.32, 20.78],
        [100.11, 20.41],
        [99.54, 20.18],
        [98.95, 19.75],
        [98.25, 19.7],
        [97.79, 18.62],
        [97.37, 18.44],
        [97.85, 17.56],
        [98.49, 16.83],
        [98.9, 16.17],
        [98.53, 15.3],
        [98.19, 15.12],
        [98.43, 14.62],
        [99.09, 13.82],
        [99.21, 13.26],
        [99.19, 12.8],
        [99.58, 11.89],
        [99.03, 10.96],
        [98.55, 9.93],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [100.11, 20.41],
        [100.54, 20.1],
        [100.6, 19.5],
        [101.28, 19.46],
        [101.03, 18.4],
        [101.05, 17.51],
        [102.11, 18.1],
        [102.41, 17.93],
        [102.99, 17.96],
        [103.2, 18.3],
        [103.95, 18.24],
        [104.71, 17.42],
        [104.77, 16.44],
        [105.58, 15.57],
        [105.54, 14.72],
        [105.21, 14.27],
        [104.28, 14.41],
        [102.98, 14.22],
        [102.34, 13.39],
        [102.58, 12.18],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [101.17, 21.43],
        [101.27, 21.2],
        [101.8, 21.17],
        [101.65, 22.31],
        [102.17, 22.46],
        [102.75, 21.67],
        [103.2, 20.76],
        [104.43, 20.75],
        [104.82, 19.88],
        [104.18, 19.62],
        [103.89, 19.26],
        [105.09, 18.66],
        [105.92, 17.48],
        [106.55, 16.6],
        [107.31, 15.9],
        [107.56, 15.2],
        [107.38, 14.2],
        [106.49, 14.57],
        [106.04, 13.88],
        [105.21, 14.27],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[107.38, 14.2], [107.61, 13.53], [107.49, 12.33], [105.81, 11.56], [106.24, 10.96], [105.19, 10.88], [104.33, 10.48]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [102.17, 22.46],
        [102.7, 22.7],
        [103.5, 22.7],
        [104.47, 22.81],
        [105.32, 23.35],
        [105.81, 22.97],
        [106.72, 22.79],
        [106.56, 22.21],
        [107.04, 21.81],
        [108.05, 21.55],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[102.14, 6.22], [101.81, 5.81], [101.15, 5.69], [101.07, 6.2], [100.25, 6.64], [100.08, 6.46]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [117.88, 4.13],
        [117.01, 4.3],
        [115.86, 4.3],
        [115.51, 3.16],
        [115.13, 2.82],
        [114.62, 1.43],
        [113.8, 1.21],
        [112.85, 1.49],
        [112.38, 1.41],
        [111.79, 0.9],
        [111.15, 0.97],
        [110.51, 0.77],
        [109.83, 1.33],
        [109.66, 2.0],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [87.3, 49.21],
        [87.75, 49.29],
        [88.01, 48.59],
        [88.85, 48.06],
        [90.28, 47.69],
        [90.97, 46.88],
        [90.58, 45.71],
        [90.94, 45.28],
        [92.13, 45.11],
        [93.48, 44.97],
        [94.68, 44.35],
        [95.3, 44.24],
        [95.76, 43.31],
        [96.34, 42.72],
        [97.45, 42.74],
        [99.51, 42.52],
        [100.84, 42.66],
        [101.83, 42.51],
        [103.31, 41.9],
        [104.52, 41.9],
        [104.96, 41.59],
        [106.12, 42.13],
        [107.74, 42.48],
        [109.24, 42.51],
        [110.41, 42.87],
        [111.12, 43.4],
        [111.82, 43.74],
        [111.66, 44.07],
        [111.34, 44.45],
        [111.87, 45.1],
        [112.43, 45.01],
        [113.46, 44.8],
        [114.46, 45.33],
        [115.98, 45.72],
        [116.71, 46.38],
        [117.42, 46.67],
        [118.87, 46.8],
        [119.66, 46.69],
        [119.77, 47.04],
        [118.86, 47.74],
        [118.06, 48.06],
        [117.29, 47.69],
        [116.3, 47.85],
        [115.74, 47.72],
        [115.48, 48.13],
        [116.19, 49.13],
        [116.67, 49.88],
        [117.87, 49.51],
        [119.28, 50.14],
        [119.27, 50.58],
        [120.18, 51.64],
        [120.73, 51.96],
        [120.72, 52.51],
        [120.17, 52.75],
        [121.0, 53.25],
        [122.24, 53.43],
        [123.57, 53.45],
        [125.06, 53.16],
        [125.94, 52.79],
        [126.56, 51.78],
        [126.93, 51.35],
        [127.28, 50.73],
        [127.65, 49.76],
        [129.39, 49.44],
        [130.58, 48.72],
        [130.98, 47.79],
        [132.5, 47.78],
        [133.37, 48.18],
        [135.02, 48.47],
        [134.5, 47.57],
        [134.11, 47.21],
        [133.76, 46.11],
        [133.09, 45.14],
        [131.88, 45.32],
        [131.02, 44.96],
        [131.28, 44.11],
        [131.14, 42.92],
        [130.63, 42.9],
        [130.6, 42.39],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [87.75, 49.29],
        [88.8, 49.47],
        [90.71, 50.33],
        [92.23, 50.8],
        [93.1, 50.49],
        [94.14, 50.48],
        [94.81, 50.01],
        [95.81, 49.97],
        [97.25, 49.72],
        [98.23, 50.42],
        [97.82, 51.01],
        [98.86, 52.04],
        [99.98, 51.63],
        [100.88, 51.51],
        [102.06, 51.25],
        [102.25, 50.51],
        [103.67, 50.08],
        [104.62, 50.27],
        [105.88, 50.4],
        [106.88, 50.27],
        [107.86, 49.79],
        [108.47, 49.28],
        [109.4, 49.29],
        [110.66, 49.13],
        [111.58, 49.37],
        [112.89, 49.54],
        [114.36, 50.24],
        [114.96, 50.14],
        [115.48, 49.8],
        [116.67, 49.88],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [124.26, 39.92],
        [125.07, 40.56],
        [126.18, 41.1],
        [126.86, 41.81],
        [127.34, 41.5],
        [128.2, 41.46],
        [128.05, 41.99],
        [129.59, 42.42],
        [129.99, 42.98],
        [130.6, 42.39],
        [130.7, 42.2],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[128.34, 38.61], [128.2, 38.37], [127.78, 38.3], [127.07, 38.25], [126.68, 37.8], [126.23, 37.84], [126.17, 37.74]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[124.96, -8.89], [125.0, -9.0], [125.08, -9.39]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[141.0, -2.6], [141.01, -5.85], [141.03, -9.11]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [11.91, -5.03],
        [12.31, -4.6],
        [12.62, -4.43],
        [12.99, -4.78],
        [12.63, -4.99],
        [12.46, -5.24],
        [12.43, -5.68],
        [12.18, -5.78],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [19.0, 44.86],
        [19.36, 44.86],
        [19.11, 44.42],
        [19.59, 44.03],
        [19.45, 43.56],
        [19.21, 43.52],
        [19.03, 43.43],
        [18.7, 43.2],
        [18.5, 42.6],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[48.58, 41.8], [47.98, 41.4], [47.81, 41.15], [47.37, 41.21], [46.68, 41.82], [46.4, 41.86]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [42.34, 37.22],
        [41.83, 36.6],
        [41.28, 36.35],
        [41.38, 35.62],
        [41.0, 34.41],
        [38.79, 33.37],
        [36.83, 32.31],
        [35.71, 32.7],
        [35.7, 32.71],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[35.82, 33.27], [35.55, 33.26], [35.46, 33.08], [35.12, 33.09]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [32.73, 35.14],
        [32.91, 35.08],
        [33.19, 35.17],
        [33.38, 35.16],
        [33.45, 35.1],
        [33.47, 35.0],
        [33.52, 35.03],
        [33.67, 35.01],
        [33.86, 35.09],
        [33.97, 35.05],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[19.21, 43.52], [19.48, 43.35], [19.6, 43.21], [19.95, 43.1], [20.33, 42.89], [20.25, 42.81], [20.07, 42.58]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [44.97, 41.24],
        [45.17, 40.98],
        [45.56, 40.81],
        [45.35, 40.56],
        [45.89, 40.21],
        [45.6, 39.9],
        [46.03, 39.62],
        [46.48, 39.46],
        [46.5, 38.77],
        [46.14, 38.74],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-122.8, 49],
        [-120, 49],
        [-117.03, 49],
        [-116.04, 49],
        [-113, 49],
        [-110.0, 49],
        [-107.0, 49],
        [-104.04, 48.99],
        [-100.6, 49],
        [-97.22, 49.0],
        [-95.15, 49],
        [-95.15, 49.38],
        [-94.81, 49.38],
        [-94.6, 48.8],
        [-94.32, 48.67],
        [-93.63, 48.6],
        [-92.6, 48.4],
        [-91.6, 48.1],
        [-90.8, 48.2],
        [-89.6, 48.0],
        [-89.27, 48.01],
        [-88.37, 48.3],
        [-87.43, 47.9],
        [-86.46, 47.55],
        [-85.65, 47.22],
        [-84.87, 46.9],
        [-84.77, 46.63],
        [-84.54, 46.53],
        [-84.6, 46.43],
        [-84.33, 46.4],
        [-84.14, 46.51],
        [-84.09, 46.27],
        [-83.89, 46.11],
        [-83.61, 46.11],
        [-83.46, 45.99],
        [-83.59, 45.81],
        [-82.55, 45.34],
        [-82.33, 44.4],
        [-82.13, 43.57],
        [-82.4, 42.9],
        [-82.9, 42.4],
        [-83.1, 42.0],
        [-83.14, 41.97],
        [-83.02, 41.83],
        [-82.69, 41.67],
        [-82.43, 41.67],
        [-81.27, 42.2],
        [-80.24, 42.36],
        [-78.93, 42.86],
        [-78.9, 42.96],
        [-79.0, 43.2],
        [-79.17, 43.46],
        [-78.72, 43.62],
        [-77.73, 43.62],
        [-76.82, 43.62],
        [-76.5, 44.01],
        [-76.37, 44.09],
        [-75.31, 44.81],
        [-74.86, 45.0],
        [-73.34, 45.0],
        [-71.5, 45.0],
        [-71.4, 45.25],
        [-71.08, 45.3],
        [-70.6, 45.4],
        [-70.3, 45.91],
        [-69.99, 46.69],
        [-69.23, 47.44],
        [-68.9, 47.18],
        [-68.23, 47.35],
        [-67.79, 47.06],
        [-67.79, 45.7],
        [-67.13, 45.13],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [38.41, 17.99],
        [37.9, 17.42],
        [37.16, 17.26],
        [36.85, 16.95],
        [36.75, 16.29],
        [36.32, 14.82],
        [36.42, 14.42],
        [36.27, 13.56],
        [35.86, 12.57],
        [35.26, 12.08],
        [34.83, 11.31],
        [34.73, 10.91],
        [34.25, 10.63],
        [33.96, 9.58],
        [33.97, 8.68],
        [33.82, 8.37],
        [33.29, 8.35],
        [32.95, 7.78],
        [33.56, 7.71],
        [34.07, 7.22],
        [34.25, 6.82],
        [34.7, 6.59],
        [35.29, 5.5],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[47.78, 8.0], [44.96, 5.0], [43.66, 4.95], [42.76, 4.25], [42.12, 4.23], [41.85, 3.91]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [41.85, 3.91],
        [41.17, 3.91],
        [40.76, 4.25],
        [39.85, 3.83],
        [39.55, 3.42],
        [38.89, 3.5],
        [38.67, 3.61],
        [38.43, 3.58],
        [38.12, 3.59],
        [36.85, 4.44],
        [36.15, 4.44],
        [35.81, 4.77],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [39.2, -4.67],
        [37.76, -3.67],
        [37.69, -3.09],
        [34.07, -1.05],
        [33.9, -0.9],
        [33.89, 0.1],
        [34.1, 0.51],
        [34.67, 1.17],
        [35.03, 1.9],
        [34.59, 3.05],
        [34.47, 3.55],
        [34.0, 4.24],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-8.66, 27.65],
        [-8.81, 27.65],
        [-8.79, 27.12],
        [-9.41, 27.08],
        [-9.73, 26.86],
        [-10.18, 26.86],
        [-10.55, 26.99],
        [-11.39, 26.88],
        [-11.71, 26.1],
        [-12.03, 26.03],
        [-12.5, 24.77],
        [-13.89, 23.69],
        [-14.22, 22.31],
        [-14.63, 21.86],
        [-14.75, 21.5],
        [-17.0, 21.42],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [11.02, 58.85],
        [11.46, 59.43],
        [12.3, 60.11],
        [12.63, 61.29],
        [11.99, 61.8],
        [11.93, 63.12],
        [12.57, 64.06],
        [13.57, 64.04],
        [13.91, 64.44],
        [13.55, 64.78],
        [15.1, 66.19],
        [16.1, 67.3],
        [16.76, 68.01],
        [17.72, 68.01],
        [17.99, 68.56],
        [19.87, 68.4],
        [20.02, 69.06],
        [20.64, 69.1],
        [21.24, 69.37],
        [22.35, 68.84],
        [23.66, 68.89],
        [24.73, 68.64],
        [25.68, 69.09],
        [26.17, 69.82],
        [27.73, 70.16],
        [29.01, 69.76],
        [28.59, 69.06],
        [29.39, 69.15],
        [31.1, 69.55],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [40.31, -10.31],
        [39.52, -10.89],
        [38.42, -11.28],
        [37.82, -11.26],
        [37.47, -11.56],
        [36.77, -11.59],
        [36.51, -11.72],
        [35.31, -11.43],
        [34.55, -11.52],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [32.75, -9.23],
        [33.23, -9.67],
        [33.48, -10.52],
        [33.31, -10.79],
        [33.11, -11.6],
        [33.3, -12.43],
        [32.99, -12.78],
        [32.68, -13.71],
        [33.21, -13.97],
        [30.17, -14.79],
        [30.27, -15.5],
        [29.51, -15.64],
        [28.94, -16.04],
        [28.82, -16.38],
        [28.46, -16.46],
        [27.59, -17.29],
        [27.04, -17.93],
        [26.7, -17.96],
        [26.38, -17.84],
        [25.26, -17.73],
        [25.08, -17.66],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [34.5, -11.5],
        [34.2, -12.2],
        [34.5, -13.5],
        [34.9, -13.56],
        [35.26, -13.88],
        [35.68, -14.61],
        [35.77, -15.89],
        [35.33, -16.1],
        [35.03, -16.8],
        [34.38, -16.18],
        [34.3, -15.47],
        [34.51, -15.01],
        [34.45, -14.61],
        [34.06, -14.35],
        [33.78, -14.45],
        [33.21, -13.97],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [30.83, 3.5],
        [30.77, 2.33],
        [31.17, 2.2],
        [30.85, 1.84],
        [30.46, 1.58],
        [30.08, 1.06],
        [29.87, 0.59],
        [29.81, -0.2],
        [29.58, -0.58],
        [29.57, -1.34],
        [29.29, -1.62],
        [29.25, -2.21],
        [29.11, -2.29],
        [29.02, -2.83],
        [29.27, -3.29],
        [29.3, -4.5],
        [29.5, -5.4],
        [29.4, -5.9],
        [29.6, -6.5],
        [30.2, -7.0],
        [30.7, -8.3],
        [30.34, -8.23],
        [29.0, -8.4],
        [28.73, -8.52],
        [28.44, -9.16],
        [28.67, -9.6],
        [28.49, -10.78],
        [28.37, -11.79],
        [28.64, -11.97],
        [29.34, -12.36],
        [29.61, -12.17],
        [29.69, -13.25],
        [28.93, -13.24],
        [28.52, -12.69],
        [28.15, -12.27],
        [27.38, -12.13],
        [27.16, -11.6],
        [26.55, -11.92],
        [25.75, -11.78],
        [25.41, -11.33],
        [24.78, -11.23],
        [24.31, -11.26],
        [24.25, -10.95],
        [23.91, -10.92],
        [23.45, -10.86],
        [22.83, -11.01],
        [22.4, -10.99],
        [22.15, -11.08],
        [22.2, -9.89],
        [21.87, -9.52],
        [21.8, -8.9],
        [21.94, -8.3],
        [21.74, -7.92],
        [21.72, -7.29],
        [20.51, -7.29],
        [20.6, -6.93],
        [20.09, -6.94],
        [20.03, -7.11],
        [19.41, -7.15],
        [19.16, -7.73],
        [19.01, -7.98],
        [18.46, -7.84],
        [18.13, -7.98],
        [17.47, -8.06],
        [17.0, -7.54],
        [16.86, -7.22],
        [16.57, -6.62],
        [16.32, -5.87],
        [13.37, -5.86],
        [13.02, -5.98],
        [12.73, -5.96],
        [12.32, -6.1],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [30.46, -2.41],
        [30.52, -2.8],
        [30.74, -3.03],
        [30.75, -3.35],
        [30.5, -3.56],
        [30.11, -4.09],
        [29.75, -4.45],
        [29.3, -4.5],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [20.25, 42.81],
        [20.49, 42.88],
        [20.63, 43.21],
        [20.81, 43.27],
        [20.95, 43.13],
        [21.14, 43.06],
        [21.27, 42.9],
        [21.43, 42.86],
        [21.63, 42.67],
        [21.77, 42.68],
        [21.66, 42.43],
        [21.54, 42.32],
        [21.57, 42.24],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[-71.7, 18.04], [-71.68, 18.31], [-71.94, 18.61], [-71.7, 18.78], [-71.62, 19.16], [-71.71, 19.71]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[48.94, 11.41], [48.94, 11.39], [48.93, 10.98], [48.93, 9.97], [48.93, 9.45], [48.48, 8.83], [47.78, 8.0]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[-69.59, -17.58], [-69.85, -18.09], [-70.37, -18.34]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[34.92, 29.5], [34.26, 31.21]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[35.71, 32.7], [35.54, 32.39]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[35.82, 33.28], [36.06, 33.82], [36.61, 34.2], [36.44, 34.59], [35.99, 34.64]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [35.54, 32.39],
        [35.54, 32.39],
        [35.18, 32.53],
        [34.97, 31.86],
        [35.22, 31.75],
        [34.97, 31.61],
        [34.92, 31.35],
        [35.39, 31.48],
        [35.39, 31.48],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[35.7, 32.71], [35.83, 32.86], [35.82, 33.27], [35.82, 33.28]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [29.0, 9.6],
        [29.51, 9.79],
        [29.61, 10.08],
        [29.99, 10.29],
        [30.83, 9.7],
        [31.35, 9.81],
        [31.85, 10.53],
        [32.4, 11.08],
        [32.31, 11.68],
        [32.07, 11.97],
        [32.67, 12.02],
        [32.74, 12.24],
        [33.2, 12.17],
        [33.08, 11.44],
        [33.2, 10.72],
        [33.72, 10.32],
        [33.84, 9.98],
        [33.82, 9.48],
        [33.96, 9.46],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [23.88, 8.61],
        [24.53, 8.91],
        [24.79, 9.81],
        [25.06, 10.27],
        [25.79, 10.41],
        [25.96, 10.13],
        [26.47, 9.55],
        [26.75, 9.46],
        [27.11, 9.63],
        [27.83, 9.6],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [34.0, 4.24],
        [33.3, 3.7],
        [32.68, 3.79],
        [31.88, 3.55],
        [31.24, 3.78],
        [30.83, 3.5],
        [29.95, 4.17],
        [29.71, 4.6],
        [29.15, 4.38],
        [28.69, 4.45],
        [28.42, 4.28],
        [27.97, 4.4],
        [27.37, 5.23],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[27.83, 9.6], [27.97, 9.39], [28.96, 9.39], [29.0, 9.6]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[35.29, 5.5], [34.62, 4.84], [34.0, 4.24]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[35.81, 4.77], [35.81, 5.33], [35.29, 5.5]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[33.94, -9.69], [33.73, -9.41], [32.75, -9.23], [32.19, -8.93], [31.55, -8.76], [31.15, -8.59], [30.7, -8.3]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[34.55, -11.52], [34.2, -10.1], [33.94, -9.69]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[-2.16, 35.16], [-1.79, 34.52], [-1.73, 33.91], [-1.38, 32.86], [-1.12, 32.65], [-1.3, 32.26]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-1.3, 32.26],
        [-2.61, 32.09],
        [-3.06, 31.72],
        [-3.64, 31.63],
        [-3.69, 30.89],
        [-4.85, 30.5],
        [-5.24, 30.0],
        [-6.06, 29.73],
        [-7.05, 29.57],
        [-8.67, 28.84],
        [-8.66, 27.65],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[75.15, 37.13], [75.89, 36.66], [76.19, 35.89], [77.83, 35.49]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [78.81, 33.5],
        [79.2, 32.99],
        [79.17, 32.48],
        [78.45, 32.61],
        [78.73, 31.51],
        [79.72, 30.88],
        [81.11, 30.18],
        [80.47, 29.72],
        [80.08, 28.79],
        [81.05, 28.41],
        [82, 27.92],
        [83.3, 27.36],
        [84.67, 27.23],
        [85.25, 26.72],
        [86.02, 26.63],
        [87.22, 26.39],
        [88.06, 26.41],
        [88.17, 26.81],
        [88.04, 27.44],
        [88.12, 27.87],
        [88.73, 28.08],
        [88.81, 27.29],
        [88.83, 27.09],
        [89.74, 26.71],
        [90.37, 26.87],
        [91.21, 26.8],
        [92.03, 26.83],
        [92.1, 27.45],
        [91.69, 27.77],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[77.83, 35.49], [78.91, 34.32], [78.81, 33.5]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [91.69, 27.77],
        [92.5, 27.89],
        [93.41, 28.64],
        [94.56, 29.27],
        [95.4, 29.03],
        [96.11, 29.45],
        [96.58, 28.83],
        [96.24, 28.41],
        [97.32, 28.26],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[-57.14, 5.97], [-57.3, 5.07], [-57.91, 4.81], [-57.86, 4.57], [-58.04, 4.06], [-57.6, 3.33]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[-53.95, 5.75], [-54.47, 4.89], [-54.39, 4.21], [-54.0, 3.62], [-54.18, 3.18]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[-57.6, 3.33], [-57.28, 3.33], [-57.15, 2.76], [-56.53, 1.89]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[-54.18, 3.18], [-54.26, 2.73], [-54.52, 2.31]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[42.77, 10.92], [42.55, 10.57], [42.92, 10.02], [43.29, 9.54], [43.67, 9.18], [46.94, 7.99], [47.78, 8.0]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[41.85, 3.91], [40.98, 2.78], [40.99, -0.85], [41.58, -1.68]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [[77.83, 35.49], [76.87, 34.65], [75.75, 34.5], [74.24, 34.74], [73.74, 34.31], [74.1, 33.44], [74.45, 32.76]],
    },
  },
]
export default dataBorders
